// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AddItemModalQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AddItemModalQuery = { __typename?: 'Query', items: Array<{ __typename?: 'Item', id: string, displayName: string, isSelection: boolean }>, locations: Array<{ __typename?: 'Location', id: string, name: string }> };


export const AddItemModalDocument = gql`
    query AddItemModal {
  items(filter: {status: [ACTIVE]}) {
    id
    displayName
    isSelection
  }
  locations {
    id
    name
  }
}
    `;

/**
 * __useAddItemModalQuery__
 *
 * To run a query within a React component, call `useAddItemModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddItemModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddItemModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useAddItemModalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AddItemModalQuery, AddItemModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddItemModalQuery, AddItemModalQueryVariables>(AddItemModalDocument, options);
      }
export function useAddItemModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddItemModalQuery, AddItemModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddItemModalQuery, AddItemModalQueryVariables>(AddItemModalDocument, options);
        }
export function useAddItemModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddItemModalQuery, AddItemModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddItemModalQuery, AddItemModalQueryVariables>(AddItemModalDocument, options);
        }
export type AddItemModalQueryHookResult = ReturnType<typeof useAddItemModalQuery>;
export type AddItemModalLazyQueryHookResult = ReturnType<typeof useAddItemModalLazyQuery>;
export type AddItemModalSuspenseQueryHookResult = ReturnType<typeof useAddItemModalSuspenseQuery>;
export type AddItemModalQueryResult = Apollo.QueryResult<AddItemModalQuery, AddItemModalQueryVariables>;